

















































import Vue from "vue";
import _ from "lodash";
import { Faq } from "../types/faq";

declare var _hmt: any;
declare var captcha: any;

export default Vue.extend({
	name: "faq",
	data(): Faq {
		return {
			checkTypeLocal: "inspect",
		};
	},
	mounted() {},
	computed: {},
	watch: {},
	methods: {
		// 修改检测类型触发方法
		changeCheckType() {},
	},
	created() {},
});
